export function mergeOptions<T>(
	classType: { options: T },
	options: Partial<T> | undefined,
	element?: HTMLElement
): T {
	return {
		...classType.options,
		...options,
		...(element?.dataset
			? Object.keys(element.dataset).reduce((acc, key) => {
					let val: string | number | boolean | undefined = element.dataset[key];
					if (val) {
						if (val === 'true') {
							val = true;
						} else if (val === 'false') {
							val = false;
						} else if (isNumeric(val)) {
							val = parseFloat(val);
						}
						acc[key] = val;
					}
					return acc;
			  }, {})
			: ({} as any)),
	};
}

function isNumeric(str: any) {
	return !isNaN(str) && !isNaN(parseFloat(str));
}
